import * as React from "react";
import "./SimpleYoutube.css";

type Props = {
  id: string;
};
export default function SimpleYoutube(props: Props) {
  const { id } = props;
  return (
    <div className="video-container">
      <iframe
        src={`https://www.youtube.com/embed/${id}`}
        frameborder="0"
        allowfullscreen
      ></iframe>
    </div>
  );
}
